import { lazy } from "react";
import ElectedLeaderboard from "./pages/dashboard/leaderboard/ElectedLeaderboard.jsx";
import ElectedMembers from "./pages/dashboard/members/ElectedMembers.jsx";

const Login = lazy(() => import("./pages/login/Login"));
const DashboardLayout = lazy(() => import("./pages/dashboard/DashboardLayout"));
const Ngo = lazy(() => import("./pages/dashboard/ngo/Ngo.jsx"));
const RegisterNgo = lazy(() =>
  import("./pages/dashboard/ngo/register-ngo/RegisterNgo.jsx")
);
const NgoReview = lazy(() =>
  import("./pages/dashboard/ngo/review/NgoReview.jsx")
);
const Events = lazy(() => import("./pages/dashboard/events/Events.jsx"));
const Event = lazy(() => import("./pages/dashboard/events/event/Event.jsx"));
const EventReview = lazy(() =>
  import("./pages/dashboard/events/review/EventReview.jsx")
);
const RegisteEvent = lazy(() =>
  import("./pages/dashboard/events/register-event/RegisterEvent.jsx")
);
const Discount = lazy(() => import("./pages/dashboard/discounts/Discount.jsx"));
const RegisterDiscounts = lazy(() =>
  import("./pages/dashboard/discounts/register-discount/RegisterDiscounts.jsx")
);
const TotalMembers = lazy(() =>
  import("./pages/dashboard/members/TotalMembers.jsx")
);
const LeagueMembers = lazy(() =>
  import("./pages/dashboard/members/LeagueMembers.jsx")
);
const LeagueLeaderboard = lazy(() =>
  import("./pages/dashboard/leaderboard/LeagueLeaderboard.jsx")
);
const TotalLeaderboard = lazy(() =>
  import("./pages/dashboard/leaderboard/TotalLeaderboard.jsx")
);

let routes = [
  { path: `/`, element: <Login /> },
  // { path: `/dashboard`, element: <DashboardLayout /> },
  //   TODO: Make the Routes dynamic
  {
    path: `/dashboard`,
    element: <DashboardLayout />,
    children: [
      { path: "ngo", element: <Ngo /> },
      { path: "ngo/register-ngo", element: <RegisterNgo /> },
      { path: "ngo/review/:ngoId", element: <NgoReview /> },
      { path: "events", element: <Events /> },
      { path: "events/register-event", element: <RegisteEvent /> },
      { path: "events/:eventId", element: <Event /> },
      { path: "events/review/:eventId", element: <EventReview /> },
      { path: "discounts", element: <Discount /> },
      { path: "discounts/register-discount", element: <RegisterDiscounts /> },
      { path: "members/total", element: <TotalMembers /> },
      { path: "members/league", element: <LeagueMembers /> },
      { path: "members/elected", element: <ElectedMembers /> },
      { path: "leaderboard/league", element: <LeagueLeaderboard /> },
      { path: "leaderboard/total", element: <TotalLeaderboard /> },
      { path: "leaderboard/elected", element: <ElectedLeaderboard /> },
    ],
  },
];

export default routes;
